import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import { StyledTitle as Title } from '../../fields/Title';
import YellowImage from '../../../assets/landing-image-yellow.svg';
import LearningImage from '../../../assets/learning.svg';
import MobileImage from '../../../assets/mobile.svg';
import MicroScopeImage from '../../../assets/microscope.svg';
import { StyledButton } from '../../../styles/StyledComponents';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

export const WhatIsTutorD = () => {
  return (
    <>
      <Row justify='center'>
        <Col
          xl={20}
          sm={22}
          style={{
            background: '#fff',
            padding: 40,
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
          }}
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 40 }}>
            {/* LEFT COLUMN */}
            <Col xl={12}>
              <img src={YellowImage} alt='' />
            </Col>
            {/* RIGHT COLUMN */}
            <Col xl={12}>
              <Title level={2} style={{ color: '#333', fontWeight: 'bolder' }}>
                <FormattedMessage id='landing.main.title'/>
              </Title>
              <br />
              <strong style={{ color: '#333' }}>
                <FormattedMessage id='landing.main.descriptionOne'/>
              </strong>
              <br />
              <br />
              <p>
                <FormattedMessage id='landing.main.descriptionTwo'/>
              </p>
              <br />
              <Link to='/sign-up'>
                <StyledButton style={{ borderRadius: 6, height: 40, width: 150 }}>
                  <FormattedMessage id='landing.main.join-now-button'/> <RightOutlined />
                </StyledButton>
              </Link>
            </Col>
          </Row>
          {/* PURPLE CONTAINER */}
          <Row justify='center' style={{ margin: '40px 0' }}>
            <Col
              xl={24}
              style={{
                background: '#8053D7',
                borderRadius: 6,
                filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
                padding: 40
              }}
            >
              <p
                style={{
                  fontSize: '2.5em',
                  fontFamily: 'Montserrat Bold',
                  color: '#fff',
                  textAlign: 'center'
                }}
              >
                <FormattedMessage id='landing.education.title'/>
                <span style={{ color: '#FFDC54' }}><FormattedMessage id='landing.education.title-link'/></span>
              </p>
              <p style={{ color: '#fff', textAlign: 'center' }}>
                <FormattedMessage id='landing.education.description'/>
              </p>
            </Col>
          </Row>
          {/* 3 ROW COLUMN */}
          <Row justify='center' gutter={[40, 40]} style={{ textAlign: 'center' }}>
            <Col xl={8}>
              <img src={MicroScopeImage} alt='' />
              <br />
              <br />
              <Title level={2} style={{ color: '#333' }}>
                <FormattedMessage id='landing.education.subTitleOne'/>
              </Title>
              <p style={{ color: '#333' }}>
                <FormattedMessage id='landing.education.descriptionOne'/>
              </p>
            </Col>
            <Col xl={8}>
              <img src={MobileImage} alt='' />
              <br />
              <br />
              <Title level={2} style={{ color: '#333' }}>
                <FormattedMessage id='landing.education.subTitleTwo'/>
              </Title>
              <p style={{ color: '#333' }}>
                <FormattedMessage id='landing.education.descriptionTwo'/>
              </p>
            </Col>
            <Col xl={8}>
              <img src={LearningImage} alt='' />
              <br />
              <br />
              <Title level={2} style={{ color: '#333' }}>
                <FormattedMessage id='landing.education.subTitleThree'/>
              </Title>
              <p style={{ color: '#333' }}>
                <FormattedMessage id='landing.education.descriptionThree'/>
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
